import { render, staticRenderFns } from "./dehumidifier.vue?vue&type=template&id=8255e4c8&scoped=true&lang=pug"
import script from "./dehumidifier.vue?vue&type=script&lang=js"
export * from "./dehumidifier.vue?vue&type=script&lang=js"
import style0 from "./dehumidifier.vue?vue&type=style&index=0&id=8255e4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8255e4c8",
  null
  
)

export default component.exports